import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=0bc5a1e2&scoped=true&"
var script = {}
import style0 from "./Warning.vue?vue&type=style&index=0&id=0bc5a1e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc5a1e2",
  null
  
)

export default component.exports